import { FunctionComponent, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminContainer from "../../components/AdminContainer";
import { UserContext } from "../../context/UserContext";

const Admin: FunctionComponent = ({}) => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (
      !user.email.toLowerCase().includes("spinlab.tech") &&
      !user.email.toLowerCase().includes("tabakjesicarosa@gmail.com") &&
      !user.email.toLowerCase().includes("kohanbrian@hotmail.com") &&
      !user.email.toLowerCase().includes("tabakbrian@gmail.com")
    ) {
      navigate("/");
    }
  }, []);
  return <AdminContainer />;
};

export default Admin;
